import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * @class Preloader
 *
 * @description
 * Class for a showing a preloader if data is being created of is being received.
 *
 * @example
 * <Preloader />
 */
export default class Preloader extends Component {

	static propTypes = {
		message: PropTypes.string
	};

	render () {
		return (
			<div className="preloader">
				<div className="preloader__animation">
					<div className="preloader__box preloader__box-1" />
					<div className="preloader__box preloader__box-2" />
					<div className="preloader__box preloader__box-3" />
					<div className="preloader__box preloader__box-4" />
				</div>
				<p className={'text-center'}>{this.props.message}</p>
			</div>
		);
	}
}
